import React, {forwardRef} from "react";
// @material-ui/core components
import { makeStyles, FormControlLabel, FormControl, FormLabel, Radio, RadioGroup } from "@material-ui/core";
// core components
import GridItem from "components/Grid/GridItem.js";

const useStyles = makeStyles(theme => ({
  root:{
    border: '1px solid blue',
    borderRadius: 3,
    padding: 5,
    width: '96%',
    marginTop: 7,
    marginBottom: 7,
    boxShadow: '1px 1px 2px gray'
  },
  group: {
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'flex-end',
    alignItems: 'center',
    fontSize: '1.2rem',
    [theme.breakpoints.down('xs')]: {
      fontSize: '4vw',
    },
  },
  text:{
    marginRight: 'auto',
  },
  formLabel: {
    marginBottom: 1,
  },
  radio: {
    border: '7px solid rgb(75, 125, 200)',
    backgroundColor: 'white',
    borderRadius: '50%',
    marginLeft: 1,
    '&:before': {
      display: 'block',
      width: 7,
      height: 7,
      content: '""',
    },
  }
}))

export const YesNoRadio = forwardRef((props, ref) => {
  const classes = useStyles();
  const fieldsize = props.fieldsize ? props.fieldsize : 12
  return (
    <GridItem xs={12} sm={12} md={fieldsize}>
      <FormControl component="fieldset" className={classes.root}>
          <FormLabel component="legend" className={classes.formLabel}>{props.label}</FormLabel>
          <RadioGroup className={classes.group} {...props}>
            <div className={classes.text}>{props.text}</div>
            <FormControlLabel value={false} checked={props.value === 'false'} label="NÃO" inputRef={ref} control={<Radio checkedIcon={<span className={classes.radio}/>} />}/>
            <FormControlLabel value={true} checked={props.value === 'true'} label="SIM" inputRef={ref} control={<Radio checkedIcon={<span className={classes.radio}/>} />}/>
          </RadioGroup>
      </FormControl>
    </GridItem>
    )
})
